var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_525_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95427 31.0457 0 20 0C8.95431 0 0 8.95427 0 20C0 31.0457 8.95431 40 20 40Z",
    fill: "#EDF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.929 18.0287C21.5375 18.0287 22.8414 16.7089 22.8414 15.0808C22.8414 13.4527 21.5375 12.1328 19.929 12.1328C18.3205 12.1328 17.0166 13.4527 17.0166 15.0808C17.0166 16.7089 18.3205 18.0287 19.929 18.0287Z",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2461 24.5912V30.6661C14.2461 31.2399 14.7025 31.7019 15.2694 31.7019H24.7301C25.297 31.7019 25.7534 31.2399 25.7534 30.6661V24.5912C25.7534 22.4946 24.0858 20.8066 22.0145 20.8066H17.9849C15.9137 20.8066 14.2461 22.4946 14.2461 24.5912Z",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4923 14.4694C11.6245 14.4694 12.5423 13.5281 12.5423 12.367C12.5423 11.2059 11.6245 10.2646 10.4923 10.2646C9.36018 10.2646 8.44238 11.2059 8.44238 12.367C8.44238 13.5281 9.36018 14.4694 10.4923 14.4694Z",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2451 18.4578C13.7919 17.6478 12.9407 17.1045 11.9612 17.1045H9.12488C7.66689 17.1045 6.49316 18.3082 6.49316 19.8035V22.9964C6.49316 23.4056 6.81441 23.7351 7.21342 23.7351H11.2923",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5077 14.4694C28.3755 14.4694 27.4577 13.5281 27.4577 12.367C27.4577 11.2059 28.3755 10.2646 29.5077 10.2646C30.6398 10.2646 31.5576 11.2059 31.5576 12.367C31.5576 13.5281 30.6398 14.4694 29.5077 14.4694Z",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7549 18.4578C26.2081 17.6478 27.0593 17.1045 28.0388 17.1045H30.8751C32.3331 17.1045 33.5068 18.3082 33.5068 19.8035V22.9964C33.5068 23.4056 33.1856 23.7351 32.7866 23.7351H28.7078",
    stroke: "black",
    strokeWidth: 1.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_525_59"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroup);
export default __webpack_public_path__ + "static/media/icon_group.dc676998ee90c56ad8acfb4891c004eb.svg";
export { ForwardRef as ReactComponent };